class userProviderDetailsController {
  constructor() {
    "ngInject"

  }

  clientsCount() {
    let count = this.user.providerInfo.clientsCount;
    if (!count) count = 0;

    return count;
  }

  totalRevenue() {
    let value = this.user.stats.totalRevenue;
    if (!value) value = 0;

    return kendo.toString(value, 'c0');
  }

  totalRevenue12Months() {
    let value = this.user.stats.totalRevenue12Months;
    if (!value) value = 0;

    return kendo.toString(value, 'c0');
  }

  totalHours() {
    let value = this.user.stats.totalWorkingHours;
    if (!value) value = 0;

    return kendo.toString(value, 'n0');
  }

  membershipFees() {
    var total = 0;
    this.user.invoices.forEach(invoice => {
      total += (invoice.adjustedTotal - invoice.amountRefunded);
    })

    total /= 100;

    return total;
  }

  membershipFeesFormatted() {
    var total = this.membershipFees();

    return kendo.toString(total, 'c0');
  }

  membershipPercentage() {
    var membershipFees = this.membershipFees();
    var totalRevenue = this.user.stats.totalRevenue;
    if (!membershipFees || !totalRevenue) return '';

    return kendo.toString(membershipFees / totalRevenue, 'p2') + ' of estimated revenue';
  }
}

export default userProviderDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-provider-details/user-provider-details.controller.js
 **/